const MAX_COMMENT_COUNT_NORMAL_MODE = 1;

export { MAX_COMMENT_COUNT_NORMAL_MODE };
